<template>
    <div class="menu">
        <img src="../assets/logo.png" class="logo">
        <div class="menu-box">
            <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">首頁    </div>
            <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">關於我們</div>
            <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">招聘信息</div>
            <div :class="step == 5 ? 'select' : ''" @click="selectMenu(5)">合作品牌</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if(value == this.step){
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "aboutUs" }); break;
                case 3: this.$router.push({ path: "legalPerson" }); break;
                case 4: this.$router.push({ path: "offers" }); break;
                case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 10px 80px;
    background: #fff;
    display: flex;
    justify-content: space-between;

    .logo {
        width: 132px;
        height: 56px;
    }

    .menu-box {
        display: flex;
        width: 700px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
    }

    .select {
        color: #4CA0D7;
        border-bottom: 4px solid #4CA0D7;
    }
}</style>